module.exports = __webpack_public_path__ + "static/img/r_001.5b53ae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/r_001.jpg
// module id = f/KV
// module chunks = 1